import { Back2 } from "../../../components/Option/Back";
import { useEffect, useState } from "react";
import gearicon from "../../../assets/shapes_svg/ambition/gearicon.svg";
import "./index.css";
import EnvironmentReport, {
  SaveAndDiscard,
  Textareawithsteroids,
} from "./EnvironmentReport";
import SocialReport from "./SocialReport";
import GovernanceReport from "./GovernanceReport";
import down from "../../../assets/shapes_svg/ambition/down.svg";
import { getHighlight, updateHighlight } from "../../../apis/Ambition";
import "../index.css";
import "./index.css";
import { ContainerBody } from "../../../App";
import { useParams } from "react-router-dom";

export const HeaderShow = ({ text, show, setShow }) => {
  return (
    <div
      className="esg__companyinfo mt-2 mb-2 w-100"
      style={{ cursor: "pointer" }}
      onClick={setShow}
    >
      <h5 className="ms-auto">{text}</h5>
      {show ? (
        <img
          onClick={setShow}
          className="ms-auto"
          style={{ cursor: "pointer" }}
          src={down}
          alt="down icon"
        />
      ) : (
        <img
          onClick={setShow}
          className="ms-auto"
          style={{ transform: "rotate(180deg)", cursor: "pointer" }}
          src={down}
          alt="up icon"
        />
      )}
    </div>
  );
};

const CompanyInfoForReport = () => {
  const [showContent, setShowContent] = useState(false);
  const [leaderLetter, setLeaderLetter] = useState(false);
  const [highlights, setHighlights] = useState(["", "", ""]);
  const [highlightsLength, setHighlightsLength] = useState(0);
  const [highlight0, setHighlight0] = useState("");
  const [highlight1, setHighlight1] = useState("");
  const [highlight2, setHighlight2] = useState("");
  const [highlight3, setHighlight3] = useState("");
  const [highlight4, setHighlight4] = useState("");
  const [highlight5, setHighlight5] = useState("");
  const [highlight6, setHighlight6] = useState("");
  const [highlight7, setHighlight7] = useState("");
  const [highlight8, setHighlight8] = useState("");
  const [highlight9, setHighlight9] = useState("");
  const [user, setUser] = useState(null);
  const { businessName } = useParams();

  useEffect(() => {
    handleGetLeaderLetter();
    handleGetHighlight();
  }, []);

  useEffect(() => {
    if (highlight9.length > 0) setHighlightsLength(10);
    else if (highlight8.length > 0) setHighlightsLength(9);
    else if (highlight7.length > 0) setHighlightsLength(8);
    else if (highlight6.length > 0) setHighlightsLength(7);
    else if (highlight5.length > 0) setHighlightsLength(6);
    else if (highlight4.length > 0) setHighlightsLength(5);
    else if (highlight3.length > 0) setHighlightsLength(4);
    else if (highlight2.length > 0) setHighlightsLength(3);
    else if (highlight1.length > 0) setHighlightsLength(2);
    else if (highlight1.length > 0) setHighlightsLength(0);
    // setHighlightsLength(length)
  }, [
    highlight0,
    highlight1,
    highlight2,
    highlight3,
    highlight4,
    highlight5,
    highlight6,
    highlight7,
    highlight8,
    highlight9,
  ]);

  const handleGetLeaderLetter = () => {
    getHighlight({
      key: "leader_letter",
      setValue: setLeaderLetter,
      setUser: setUser,
      activeCompany: businessName,
    });
  };

  const handleGetHighlight = () => {
    getHighlight({
      key: "highlight0",
      setValue: setHighlight0,
      setUser: setUser,
      activeCompany: businessName,
    });
    getHighlight({
      key: "highlight1",
      setValue: setHighlight1,
      setUser: setUser,
      activeCompany: businessName,
    });
    getHighlight({
      key: "highlight2",
      setValue: setHighlight2,
      setUser: setUser,
      activeCompany: businessName,
    });
    getHighlight({
      key: "highlight3",
      setValue: setHighlight3,
      setUser: setUser,
      activeCompany: businessName,
    });
    getHighlight({
      key: "highlight4",
      setValue: setHighlight4,
      setUser: setUser,
      activeCompany: businessName,
    });
    getHighlight({
      key: "highlight5",
      setValue: setHighlight5,
      setUser: setUser,
      activeCompany: businessName,
    });
    getHighlight({
      key: "highlight6",
      setValue: setHighlight6,
      setUser: setUser,
      activeCompany: businessName,
    });
    getHighlight({
      key: "highlight7",
      setValue: setHighlight7,
      setUser: setUser,
      activeCompany: businessName,
    });
    getHighlight({
      key: "highlight8",
      setValue: setHighlight8,
      setUser: setUser,
      activeCompany: businessName,
    });
    getHighlight({
      key: "highlight9",
      setValue: setHighlight9,
      setUser: setUser,
      activeCompany: businessName,
    });
  };

  const handleUpdateLeaderLetter = () => {
    updateHighlight({
      key: "leader_letter",
      value: leaderLetter,
      target_user: user,
    });
  };
  return (
    <>
      <HeaderShow
        text={"Company Info for Report"}
        show={showContent}
        setShow={() => setShowContent(!showContent)}
      />
      {/* <div className="esg__companyinfo">
                <h5>Company Info for Report</h5>
            </div> */}
      {showContent ? (
        <div className="esg__companyinfo__values">
          <div className="esg__companyinfo__leader">
            <div className="esg__companyinfo__header">
              <h6>
                Comment from the leader of the company, to introduce the work in
                this report:
              </h6>
            </div>
            <div className="esg__leader__value" style={{ height: "auto" }}>
              <textarea
                style={{ maxHeight: "500px" }}
                type="text"
                placeholder={
                  "E.g Letter to shareholders from chair of board/president/CEO:"
                }
                value={leaderLetter}
                onChange={(e) => setLeaderLetter(e.target.value)}
              ></textarea>
              <SaveAndDiscard
                clickSave={() => handleUpdateLeaderLetter()}
                clickDiscard={() => handleGetLeaderLetter()}
              />
            </div>
          </div>
          <div className="esg__companyinfo__highlight">
            <div className="esg__companyinfo__header">
              <h6>
                Which activities/achievements commitments would you like to
                highlight from the reporting year ?
              </h6>
            </div>

            {highlightsLength > 0 ? (
              <div className="esg__highlight__value p-4">
                <Textareawithsteroids
                  maxLength={"250"}
                  keyHighlight={"highlight0"}
                />
              </div>
            ) : null}
            {highlightsLength > 1 ? (
              <div className="esg__highlight__value p-4">
                <Textareawithsteroids
                  maxLength={"250"}
                  keyHighlight={"highlight1"}
                />
              </div>
            ) : null}
            {highlightsLength > 2 ? (
              <div className="esg__highlight__value p-4">
                <Textareawithsteroids
                  maxLength={"250"}
                  keyHighlight={"highlight2"}
                />
              </div>
            ) : null}
            {highlightsLength > 3 ? (
              <div className="esg__highlight__value p-4">
                <Textareawithsteroids
                  maxLength={"250"}
                  keyHighlight={"highlight3"}
                />
              </div>
            ) : null}
            {highlightsLength > 4 ? (
              <div className="esg__highlight__value p-4">
                <Textareawithsteroids
                  maxLength={"250"}
                  keyHighlight={"highlight4"}
                />
              </div>
            ) : null}
            {highlightsLength > 5 ? (
              <div className="esg__highlight__value p-4">
                <Textareawithsteroids
                  maxLength={"250"}
                  keyHighlight={"highlight5"}
                />
              </div>
            ) : null}
            {highlightsLength > 6 ? (
              <div className="esg__highlight__value p-4">
                <Textareawithsteroids
                  maxLength={"250"}
                  keyHighlight={"highlight6"}
                />
              </div>
            ) : null}
            {highlightsLength > 7 ? (
              <div className="esg__highlight__value p-4">
                <Textareawithsteroids
                  maxLength={"250"}
                  keyHighlight={"highlight7"}
                />
              </div>
            ) : null}
            {highlightsLength > 8 ? (
              <div className="esg__highlight__value p-4">
                <Textareawithsteroids
                  maxLength={"250"}
                  keyHighlight={"highlight8"}
                />
              </div>
            ) : null}
            {highlightsLength > 9 ? (
              <div className="esg__highlight__value p-4">
                <Textareawithsteroids
                  maxLength={"250"}
                  keyHighlight={"highlight9"}
                />
              </div>
            ) : null}

            {/* <div className="esg__highlight__value">
                        <textarea type="text" placeholder={"highlight"} ></textarea>
                    </div>
                    <div className="esg__highlight__value">
                        <textarea type="text" placeholder={"highlight"} ></textarea>
                    </div> */}
            {highlightsLength <= 10 ? (
              <div
                className="esg__highlight__value__add"
                onClick={() => {
                  if (highlightsLength <= 10)
                    setHighlightsLength(highlightsLength + 1);
                }}
              >
                <h5>+ Add Highlight</h5>
              </div>
            ) : null}
          </div>
        </div>
      ) : null}
    </>
  );
};

const EorSorG = () => {
  const [chosen, setChosen] = useState("E");
  const [user, setUser] = useState(null);
  const { businessName } = useParams();
  return (
    <>
      <div className="eorsorg__body">
        <div
          className={
            "eorsorg__each " + (chosen === "E" ? "eorsorg__chosen" : "")
          }
          onClick={() => setChosen("E")}
        >
          <h3 className="mb-2">E</h3>
          <h5 className="mb-2">Environment</h5>
          {chosen === "E" ? (
            <h6>
              In this section we need to chart some of the GHG accounting
              already made in the Company tab (if you haven't been there, that
              is the place to start), but also dive into some of the drivers for
              biodiversity and circular economy.
            </h6>
          ) : null}
        </div>
        <div
          className={
            "eorsorg__each " + (chosen === "S" ? "eorsorg__chosen" : "")
          }
          onClick={() => setChosen("S")}
        >
          <h3 className="mb-2">S</h3>
          <h5 className="mb-2">Social</h5>
          {chosen === "S" ? (
            <h6>
              In this section we dive into everything there is concerning people
              in your organisation and from your suppliers towards your clients.
              Starting with basic data employees
            </h6>
          ) : null}
        </div>
        <div
          className={
            "eorsorg__each " + (chosen === "G" ? "eorsorg__chosen" : "")
          }
          onClick={() => setChosen("G")}
        >
          <h3 className="mb-2">G</h3>
          <h5 className="mb-2">Governance</h5>
          {chosen === "G" ? (
            <h6>
              The purpose of this section is to dive into where the company in
              the governance structure can support everything from prevention of
              whitewash scandals to diversity in the board and management
            </h6>
          ) : null}
        </div>
      </div>
      {chosen === "E" ? (
        <EnvironmentReport
          user={user}
          setUser={setUser}
          businessName={businessName}
        />
      ) : chosen === "S" ? (
        <SocialReport
          user={user}
          setUser={setUser}
          businessName={businessName}
        />
      ) : chosen === "G" ? (
        <GovernanceReport
          user={user}
          setUser={setUser}
          businessName={businessName}
        />
      ) : null}
    </>
  );
};
const ESGmain = () => {
  const ESGdef = (
    <>
      ESG reporting is becoming more and more relevant as the EU pushes new
      legislation towards financial institutions and large corporations, soon to
      cascade downwards in relation to company sizes. This entails that each
      company must choose some metrics that they report on each year. It is not
      a good idea to change metrices underway so think carefully what metrics
      you use and include. This is a suggestive framework and we hope it will
      help you on the way to create a meaningful ESG report to share with your
      bank, clients and end-users, as well as use internally to benchmark your
      progress.
      <br />
      <br />
      This ESG framework is a combination of FSR guidelines, the ESG taxonomy
      from SKATs website and pushing benchmarks for Circular economy
      Biodiversity and many other things that should be measured in the
      companies. Please fill in as many as you can.
    </>
  );
  return (
    <ContainerBody className="ambition__body">
      <div
        className="companydetail__wrapper2"
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "flex-end",
          marginTop: "20px",
          height: "0",
        }}
      >
        <Back2
          header={"Back to Company Page"}
          style={{ marginRight: "auto", position: "relative", left: "-7%" }}
          to={"/ambition"}
        />
      </div>
      <div className="ambition__esg__items">
        <div
          className="ambition__role__role"
          style={{ justifyContent: "space-around", flexWrap: "wrap" }}
        >
          <div
            className="ambition__body__item"
            style={{ padding: "20px", justifyContent: "space-between" }}
          >
            <h4>ESG</h4>
            <h5>Environmental, Social & Governance</h5>
            <img src={gearicon} alt="Gear Icon" />
          </div>
          <div className="roleambition__bubble">
            <h4>What are ESG's ?</h4>
            <h5>{ESGdef}</h5>
          </div>
        </div>
        <CompanyInfoForReport />
        <EorSorG />
      </div>
    </ContainerBody>
  );
};

export default ESGmain;
